import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import "./App.css";
import Homepage from "./pages/homepage";
import ModalMenu from "./components/ModalMenu";
import MenuView from "./components/MenuView";

function App() {
  const location = useLocation()

  let background = location.state && location.state.background
  
  return (
    <div className="App">
      <Switch location={background || location}>
        <Route exact path="/" children={<Homepage />} />
        <Route exact path="/menu/:menuName" children={<MenuView />} />
      </Switch>
      {background && <Route path="/menu/:menuName" children={<ModalMenu />} />}
    </div>
  );
}

export default App;
